import type { PalantirIcon } from '@flux/design-system';

/** Ícone que representa um agente na lista de conversas. */
export const CHAT_AGENT_ICON: PalantirIcon = 'robot-outline';

/** Sessão sem título ainda (nada enviado, ou o título não gerou). */
export const CHAT_SESSION_FALLBACK_TITLE = 'Nova conversa';

/** Sessão de um agente que não está na página de agentes carregada. */
export const CHAT_SESSION_FALLBACK_AGENT_NAME = 'Agente';

/**
 * Espera entre digitar e buscar. A busca de sessões é server-side e o `ChatService` não
 * faz debounce interno — quem consome precisa fazer.
 */
export const CHAT_SESSION_SEARCH_DEBOUNCE_MS = 300;
